import * as React from 'react';

export interface FormErrorMessageProps {
  message?: string;
}

export const FormErrorMessage: React.FC<FormErrorMessageProps> = ({
  message,
}) => {
  if (!message) return null;

  return <p className='text-red-600 text-xs mt-1'>{message}</p>;
};
